import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { Desktop, Mobile } from '../../App';
import {
  CLUB,
  LP,
  MLP,
  NameInitials,
  NumberRound,
  USDT,
  dateDifferenceInDaysFromToday,
  formatUSD
} from '../../helpers/helperFunctions';

import { useWindowWide } from '../../helpers/wideScreen';
import {
  CaptionText,
  H1,
  H2,
  H3,
  H4,
  P1,
  P2,
  P3
} from '../../styles/FontStyles';
import {
  Box,
  // Button,
  Flexed,
  ProfileImage,
  ProfileImagePlaceholder,
  ProfilePicture,
  SectionSeparator
} from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';
import {
  Icon,
  IconCashBackBonus,
  IconPlus,
  IconPortfolioDiamond
} from '../../styles/Icons';
import {
  Flex,
  FlexCenter,
  Responsive,
  SectionSeparatorDark
} from '../../styles/stylesStyled';
import { Username } from './DashboardStyled';

import MavieLogo from '../../assets/icons/backOffice/mavieGoldBlue.svg';

import moment from 'moment';
import Countdown from 'react-countdown';
import ReactTooltip from 'react-tooltip';

import { useAppSelector } from '../../app/hooks';
import {
  CASHBACK_BONUS,
  EARNINGS,
  RANKING,
  SETTINGS_VIRTUAL_OFFICE
} from '../../routes/routes';
import { Office, Trophy } from '../../styles/svg';
import { User } from '../../types/loginTypes';
import { DashboardInformation } from './Dashboard.types';

interface EarningsComponentProps {
  user: User;
  backOffice: DashboardInformation | null;
}

export const EarningsComponent = ({
  user,
  backOffice
}: EarningsComponentProps) => {
  const { t } = useTranslation('dashboard');
  const history = useHistory();
  const { dashboardInfo } = useAppSelector((state) => state.dashboard);
  const wide = useWindowWide(800);

  const bonusesIcons = [
    {
      id: 'office-tooltip',
      icon: Office,
      linkTo: SETTINGS_VIRTUAL_OFFICE,
      tip: t('backoffice'),
      disabled: false
    },
    {
      id: 'ranking-tooltip',
      icon: Trophy,
      linkTo: RANKING,
      tip: t('ranking'),
      disabled: false
    },

    {
      id: 'cashback-tooltip',
      icon: IconCashBackBonus,
      linkTo: CASHBACK_BONUS,
      tip: t('fast_start_bonus'),
      disabled: false
    }
  ];

  const HubInfo = () => {
    return (
      <Flexed column justifyCenter>
        <Flexed
          center
          mb='20'
          style={{ cursor: 'pointer' }}
          onClick={() => history.push('/backoffice/settings/virtual-office')}>
          <Icon color={colors.secondary100} mr='15' fill>
            <Office />
          </Icon>
          <Flexed column>
            <P2 bold> {t('backoffice_subscription')} </P2>

            <Flexed between>
              <P3 color={colors.neutral700}>
                {t('days_left')}:{' '}
                {`${dateDifferenceInDaysFromToday(
                  dashboardInfo?.user?.currentVirtualOfficeLicence?.dateEnd
                )}`}
              </P3>

              <Icon color={colors.secondary100} fill>
                <IconPlus size={'14'} />
              </Icon>
            </Flexed>
          </Flexed>
        </Flexed>
      </Flexed>
    );
  };

  return (
    <>
      <Responsive between end='true' startSM mb='20' mbSM='16'></Responsive>
      <Box p='40px'>
        <FlexCenter>
          <div style={{ position: 'relative', marginRight: wide ? 80 : 20 }}>
            <ProfilePicture size={wide ? '280px' : '64px'}>
              {user?.profileImageUrl ? (
                <ProfileImage src={user?.profileImageUrl} alt='Upload' />
              ) : (
                <ProfileImagePlaceholder
                  size={window.innerWidth > 800 ? '280px' : '64px'}
                  font={window.innerWidth > 800 ? '96px' : '20px'}>
                  {NameInitials()}
                </ProfileImagePlaceholder>
              )}
            </ProfilePicture>
            <Desktop style={{ width: '100%' }}>
              <Username>
                <P1 ml='45' color={colors.secondary100} bold>
                  Hi {user?.username},
                </P1>
                <H3 ml='50' color={colors.neutral900}>
                  ... Helping many.
                </H3>
              </Username>
            </Desktop>
          </div>
          <div style={{ width: '100%' }}>
            <Mobile>
              <P2 color={colors.neutral900} bold>
                {' '}
                Hi {user?.username},
              </P2>
              <H3 color={colors.neutral900}>... Helping many.</H3>
            </Mobile>
            <Desktop>
              <Flexed between>
                <div></div>
                <div>
                  <Flexed between mb='12'>
                    <Flex style={{ flexWrap: 'wrap' }}>
                      <div style={{ marginRight: 50 }}>
                        <CaptionText color={colors.neutral500}>
                          {t('earnings.total_earnings')}
                        </CaptionText>
                        <H1 bold mb='4'>
                          {backOffice &&
                            formatUSD(
                              NumberRound(backOffice?.user?.totalEarnings)
                            )}{' '}
                          {USDT}
                        </H1>
                        {backOffice && (
                          <P3 flex color={colors.neutral500}>
                            <P3 color={colors.secondary100} mr='5' bold>
                              {backOffice?.user?.currentWeekEarnings > -1 &&
                                '+'}
                              {formatUSD(
                                NumberRound(
                                  backOffice?.user?.currentWeekEarnings
                                )
                              )}{' '}
                              {USDT}{' '}
                            </P3>
                            {t('earnings.this_week')}
                          </P3>
                        )}
                      </div>
                    </Flex>
                  </Flexed>

                  <Flexed column onClick={() => history.push(EARNINGS)} mb='4'>
                    <CaptionText pointer color={colors.neutral500}>
                      {USDT} {t('earnings.balance')}
                    </CaptionText>
                    <H2 pointer>
                      {formatUSD(
                        backOffice?.user?.userTickets?.availableRewardPoints
                      )}{' '}
                      {USDT}
                    </H2>
                  </Flexed>

                  <Flexed column onClick={() => history.push(EARNINGS)} mb='4'>
                    <CaptionText pointer color={colors.neutral500}>
                      Dr Odin balance
                    </CaptionText>
                    <H2 pointer>
                      {formatUSD(backOffice?.user?.userTickets?.shoppingPoints)}{' '}
                      {CLUB}
                    </H2>
                  </Flexed>
                </div>

                {/* <HubInfo /> */}
              </Flexed>
            </Desktop>
          </div>
        </FlexCenter>
        <div>
          <Mobile>
            <SectionSeparator margin='20px 0' />
            <Flex style={{ flexWrap: 'wrap' }}>
              <div style={{ marginRight: 50 }}>
                <CaptionText color={colors.neutral500}>
                  {t('earnings.total_earnings')}
                </CaptionText>
                <H2 bold mb='8'>
                  {backOffice &&
                    formatUSD(
                      NumberRound(backOffice?.user?.totalEarnings)
                    )}{' '}
                  {USDT}
                </H2>
                <P3 flex color={colors.neutral500}>
                  <P3 color={colors.secondary100} mr='5' bold>
                    +
                    {backOffice &&
                      formatUSD(
                        NumberRound(backOffice?.user?.currentWeekEarnings)
                      )}{' '}
                    {USDT}{' '}
                  </P3>
                  {t('earnings.this_week')}
                </P3>
              </div>
            </Flex>
          </Mobile>
        </div>
      </Box>

      {!wide && (
        <Box>
          <div onClick={() => history.push(EARNINGS)}>
            <CaptionText mb='4' color={colors.neutral500}>
              {USDT} {t('earnings.balance')}
            </CaptionText>
            <H4 mb='20'>
              {formatUSD(backOffice?.user?.userTickets?.availableRewardPoints)}{' '}
              {USDT}
            </H4>
          </div>

          <div onClick={() => history.push(EARNINGS)}>
            <CaptionText mb='4' color={colors.neutral500}>
              {t('earnings.club_balance')}
            </CaptionText>
            <H4 mb='20'>
              {formatUSD(backOffice?.user?.userTickets?.shoppingPoints)} {USDT}
            </H4>
          </div>

          <HubInfo />
        </Box>
      )}
      {bonusesIcons.map((tip, i) => {
        return (
          <ReactTooltip
            key={i}
            id={tip.id}
            place='top'
            effect='solid'
            backgroundColor='#fff'
            textColor={colors.neutral900}>
            {tip.tip}
          </ReactTooltip>
        );
      })}
    </>
  );
};
